import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-up-square-fill" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("input", {
      hidden: "",
      type: "file",
      ref: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args)))
    }, null, 544),
    _createElementVNode("a", {
      href: "",
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onUpload && _ctx.onUpload(...args)), ["prevent"])),
      title: _ctx.title || 'Upload CSV',
      class: "btn btn-link text-decoration-none fs-5 px-0"
    }, _hoisted_3, 8, _hoisted_1)
  ]))
}